(function () {
  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = array[i]; array[i] = array[j]; array[j] = tmp;
    }
    return array;
  }

  function initBijouxUpsell(wrapper) {
    if (!wrapper || wrapper.dataset.bijouxInit === '1') return;
    wrapper.dataset.bijouxInit = '1';

    var track = wrapper.querySelector('.js-bijoux-upsell-track');
    var dotsWrap = wrapper.querySelector('.js-bijoux-upsell-dots');
    if (!track) return;

    var maxShow = parseInt(wrapper.dataset.maxShow, 10) || 6;
    var items = Array.prototype.slice.call(track.querySelectorAll('.js-bijoux-upsell-item'));
    var shuffled = shuffle(items);
    var kept = [];

    shuffled.forEach(function (item, index) {
      if (index < maxShow) { item.style.display = ''; kept.push(item); }
      else { item.remove(); }
    });

    if (kept.length === 0) { wrapper.style.display = 'none'; return; }

    if (dotsWrap && kept.length > 1) {
      kept.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart__upsell-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Voir produit ' + (i + 1));
        dot.addEventListener('click', function () {
          item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });

      // Track the active dot from the track's actual scroll position rather than
      // IntersectionObserver: during a fast/fling swipe, multiple items can report
      // "intersecting" within the same frame and whichever entry is processed last
      // wins — which is what caused dots to jump (e.g. 3rd -> 5th) instead of
      // advancing one at a time. Deriving the index directly from scrollLeft is
      // exact and matches what the user is actually looking at.
      var dotEls = Array.prototype.slice.call(dotsWrap.querySelectorAll('.cart__upsell-dot'));
      var scrollRAF = null;
      function updateActiveDot() {
        scrollRAF = null;
        var width = track.clientWidth || 1;
        var idx = Math.round(track.scrollLeft / width);
        idx = Math.max(0, Math.min(idx, kept.length - 1));
        dotEls.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }
      track.addEventListener('scroll', function () {
        if (scrollRAF) return;
        scrollRAF = requestAnimationFrame(updateActiveDot);
      }, { passive: true });
    }
  }

  function scanAndInit(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.js-bijoux-upsell').forEach(initBijouxUpsell);
  }

  scanAndInit(document);

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('js-bijoux-upsell')) {
          initBijouxUpsell(node);
        } else {
          scanAndInit(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Keep the variant <select> in sync with the hidden id input used for add-to-cart.
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('cart__upsell-select')) return;
    var item = e.target.closest('.cart__upsell-item');
    if (!item) return;
    var hiddenInput = item.querySelector('.cart__upsell-hidden-id');
    if (hiddenInput) { hiddenInput.value = e.target.value; }
  });

  function getRoutes() {
    return (window.theme && window.theme.routes) || {};
  }

  function refreshCartUI(cart) {
    var routes = getRoutes();
    var cartPage = routes.cartPage || '/cart';
    return fetch(cartPage + '?view=ajax', { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelector('.cart__items');
        var newDiscounts = doc.querySelector('.cart__discounts, [data-discounts]');
        document.querySelectorAll('[data-products]').forEach(function (target) {
          if (newItems) { target.innerHTML = newItems.innerHTML; }
        });
        if (newDiscounts) {
          var discountsHTML = newDiscounts.outerHTML;
          document.querySelectorAll('[data-discounts]').forEach(function (target) {
            target.innerHTML = discountsHTML;
          });
        }
        document.querySelectorAll('[data-subtotal]').forEach(function (target) {
          if (cart && typeof cart.total_price !== 'undefined') {
            target.textContent = formatMoney(cart.total_price);
          }
        });
        if (cart) {
          document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
            bubble.textContent = cart.item_count;
            bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
          });
        }
        // Re-scan in case the freshly injected markup needs (re)initializing.
        scanAndInit(document);
      });
  }

  function defaultMoneyFormat(cents, withDecimals) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return withDecimals ? parts.join('.') : parts[0];
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    format = format || (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) { return '$' + defaultMoneyFormat(cents, true); }

    var value;
    switch (match[1]) {
      case 'amount':
        value = defaultMoneyFormat(cents, true);
        break;
      case 'amount_no_decimals':
        value = defaultMoneyFormat(cents, false);
        break;
      default:
        value = defaultMoneyFormat(cents, true);
    }
    return format.replace(placeholderRegex, value);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart__upsell-add');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var item = btn.closest('.cart__upsell-item');
    if (!item) return;
    var idInput = item.querySelector('.cart__upsell-hidden-id');
    var qtyInput = item.querySelector('.cart__upsell-hidden-qty');
    var id = idInput ? idInput.value : null;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!id) return;

    var routes = getRoutes();
    var addUrl = routes.cartAdd || '/cart/add.js';
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (result) {
        if (result && result.status) {
          throw new Error(result.description || 'Add to cart failed');
        }
        var cartRoute = routes.cart || '/cart.js';
        return fetch(cartRoute, { credentials: 'same-origin' });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return refreshCartUI(cart); })
      .catch(function (err) {
        console.error('[bijoux-upsell] add to cart failed', err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
